import { combineReducers } from 'redux';

import {
    REQUEST_TEMPORARY_USER,
    RECEIVE_TEMPORARY_USER,
    FAILURE_TEMPORARY_USER
} from './constants';

const user = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_TEMPORARY_USER:
            return action.response.payload;
        case REQUEST_TEMPORARY_USER:
        case FAILURE_TEMPORARY_USER:
            return {};
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_TEMPORARY_USER:
            return true;
        case FAILURE_TEMPORARY_USER:
        case RECEIVE_TEMPORARY_USER:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_TEMPORARY_USER:
            return action.response.message;
        case REQUEST_TEMPORARY_USER:
        case RECEIVE_TEMPORARY_USER:
            return '';
        default:
            return state;
    }
};

export default combineReducers({ user, fetching, error });



// WEBPACK FOOTER //
// ./src/services/tempuser/reducer.js